'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var legacyUrl = {
  sandbox: 'http://qa.surfline.com',
  staging: 'http://staging.surfline.com',
  production: 'http://www.surfline.com'
}[process.env.NODE_ENV || 'production'];

var defaultNewsLinks = exports.defaultNewsLinks = [{ display: 'All', href: '/surf-news' }, { display: 'Breaking', href: '/category/breaking' }, { display: 'Features', href: '/category/features' }, { display: 'Video', href: '/category/video' }, { display: 'Travel', href: '/category/travel' }, { display: 'Gear', href: '/category/gear' }, { display: 'Training', href: '/category/training' }, { display: 'Science', href: '/category/science' }, { display: 'Hurricanes', href: '/series/hurricane' }];

var defaultAccountLinks = exports.defaultAccountLinks = [{ display: 'Account', href: '/account', newWindow: false }, { display: 'Subscriptions', href: '/account/subscription', newWindow: false }, { display: 'Quad Cam', href: legacyUrl + '/surfdata/report_quadcam.cfm', newWindow: true }, { display: 'Favorites', href: '/account/favorites', newWindow: false }, { display: 'Surf Alerts', href: '/surf-alerts', newWindow: true }];

var camsReportsLinks = exports.camsReportsLinks = [{ display: 'All Surf Spots', href: '/surf-reports-forecasts-cams', newWindow: false }, { display: 'Map', href: '/surf-reports-forecasts-cams-map', newWindow: false }, { display: 'Quad Cam', href: legacyUrl + '/surfdata/report_quadcam.cfm', newWindow: true }];

var forecastsLinks = exports.forecastsLinks = [{
  display: 'Wave Buoys',
  href: legacyUrl + '/surfline/forecasts/realtime_buoys.cfm',
  newWindow: true
}, { display: 'Charts', href: legacyUrl + '/surf-charts/', newWindow: false }, { display: 'LOLA Classic', href: legacyUrl + '/surfline/lola/home.jsp', newWindow: true }, { display: 'Meet the Forecasters', href: legacyUrl + '/forecasters/', newWindow: true }, { display: 'Hurricanes', href: '/series/hurricane', newWindow: true }];


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewNavigationBar/defaultLinks.js
// module id = 166
// module chunks = 11